import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

/**
 * @name CaptureSoftTokenActivationPasswordEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationPasswordEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "DemoUser")
    .update([ "password" ], "123456789012")
    .submit();

    return <LoginPage data={ data } />
}